import { FilterOption } from '../interfaces/filteroption.interface';

export class Filter {
  name = '';
  label = '';
  options: FilterOption[] = [];

  constructor(filter?: Filter) {
    if (filter) {
      this.name = filter.name;
      this.label = filter.label;
      this.options = filter.options.map((option: FilterOption) =>
        option.clone(),
      );
    }
  }

  clone(): Filter {
    return new Filter(this);
  }
}
